module.exports = __webpack_public_path__ + "img/serviceIcon.b131b484.png";